document.addEventListener( 'DOMContentLoaded', () => {

	/**
	 * Updates the CSS variable `--overlay-height` for each `.b-two-columns` block.
	 *
	 * @function updateOverlayHeights
	 * @return {void} Does not return a value. Updates DOM styles directly.
	 */
	const updateOverlayHeights = () => {

		document.querySelectorAll( '.b-two-columns' ).forEach( ( block ) => {

			const inner = block.querySelector( '.b-two-columns__inner' );
			if ( !inner ) {

				return;

			}

			let targetColumn = null;

			if ( block.classList.contains( 'b-two-columns--overlay' ) && block.classList.contains( 'b-two-columns--overlay-left' ) ) {

				targetColumn = inner.children[0];

			} else if ( block.classList.contains( 'b-two-columns--overlay' ) && block.classList.contains( 'b-two-columns--overlay-right' ) ) {

				targetColumn = inner.children[1];

			}

			if ( !targetColumn ) {

				return;

			}

			const height = targetColumn.offsetHeight;
			block.style.setProperty( '--overlay-height', `${height}px` );

		} );

	};

	let resizeTimeout;

	/**
	 * Debounces the execution of `updateOverlayHeights` on window resize.
	 *
	 * @function debounceUpdate
	 * @return {void} Does not return a value. Triggers `updateOverlayHeights` after debounce delay.
	 */
	const debounceUpdate = () => {

		clearTimeout( resizeTimeout );
		resizeTimeout = setTimeout( updateOverlayHeights, 200 );

	};

	updateOverlayHeights();

	window.addEventListener( 'resize', debounceUpdate );

	window.addEventListener( 'load', updateOverlayHeights );

} );
